import React, { Component } from 'react';
import {connect, Provider} from "react-redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import thunk from "redux-thunk";

import RegisterToolbar from "./components/toolbar";
import { ReadOnlyRegisterTable } from "./components/table/readOnlyTable";
import { EditableRegisterTable } from "./components/table/editableTable";
import { RegisterMessagesWrapper } from "./components/messaging";
import Loader from "../components/Loader";

import { resetPageCount } from "./core/actions/pagination";
import { loading} from "./core/reducers/loading";
import { messages} from "./core/reducers/messaging";
import { immutableBaseData, mutableBaseData } from "./core/reducers/data";
import { immutableEditing, mutableEditing } from "./core/reducers/editing";
import { immutableFiltering, mutableFiltering } from "./core/reducers/filtering";
import { immutablePagination, mutablePagination } from "./core/reducers/pagination";
import { immutableSearching, mutableSearching } from "./core/reducers/searching";
import { fetchAppData } from "./core/actions/data";
import { mutableSorting } from "./core/reducers/sorting";
import { immutableInterface, mutableInterface } from "./core/reducers/interface";
import { InterfaceListener } from "./components/interfaceListener";

import pathJoin from '../utils/path.join'

class _RegisterTableWrapper extends Component {

    componentDidUpdate() {
        // whenever we switch between register table types we want to do some tidying up
        this.props.dispatch( resetPageCount() )
    }

    render() {
        return this.props.editingEnabled ? (
            <EditableRegisterTable />
        ) : (
            <ReadOnlyRegisterTable />
        )
    }

}

const RegisterTableWrapper = connect((state) => ({
    editingEnabled: state.immutableEditing.editingEnabled,
}))(_RegisterTableWrapper);


const _RegisterApp = ({ initialised, loaded }) => (
    <div>
        { ( initialised && loaded ) || <Loader /> }
        { initialised && <RegisterToolbar /> }
        { initialised && <RegisterMessagesWrapper /> }
        { initialised && <RegisterTableWrapper /> }
        { initialised && <InterfaceListener />}
    </div>
);

const RegisterApp = connect((state) => ({
    initialised: !state.loading.appInitialising,
    loaded: !state.loading.appLoading,
}))(_RegisterApp);


export function createRegisterApp(preloadedState) {

    const reducers = combineReducers({
            loading,
            messages,
            immutableBaseData,
            immutableEditing,
            immutableFiltering,
            immutablePagination,
            immutableSearching,
            immutableInterface,
            mutableBaseData,
            mutableEditing,
            mutableFiltering,
            mutablePagination,
            mutableSearching,
            mutableSorting,
            mutableInterface,
        });

        // because we are using preloaded state we need to hook up the redux dev tools using enhancers
        const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
        const store = createStore(
            reducers,
            preloadedState,
            composeEnhancers( applyMiddleware(thunk) ),
        );
        window.Store = store;

        // we need to alter the url to be the data route of the current url, while keeping the other
        // components the same especially any query parameters. And be ie friendly.
        store.dispatch(
            fetchAppData(
                pathJoin([location.protocol, '/', location.host, location.pathname, 'data', location.search])
            )
        );

        return (
            <Provider store={ store }>
                <RegisterApp />
            </Provider>
        )
}


